export class PusherModel {

}